/*
  Contact form component - migrated from jwt-bch-frontend
*/

import React, { useState, useCallback } from 'react'
import { Form, Button, Alert, Toast, ToastContainer } from 'react-bootstrap'
import Captcha from './captcha'

// const SERVER = process.env.REACT_APP_AUTHSERVER || process.env.AUTHSERVER || 'https://auth.fullstack.cash'
const SERVER = 'https://email.fullstack.cash'

function ContactForm () {
  const [name, setName] = useState('')
  const [email, setEmail] = useState('')
  const [formMessage, setFormMessage] = useState('')
  const [message, setMessage] = useState('')
  const [captchaIsValid, setCaptchaIsValid] = useState(false)
  const [showSuccess, setShowSuccess] = useState(false)
  const [showError, setShowError] = useState(false)
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [showToast, setShowToast] = useState(false)
  const [toastTitle, setToastTitle] = useState('')
  const [toastMessage, setToastMessage] = useState('')
  const [toastVariant, setToastVariant] = useState('success')

  const validateEmail = (email) => {
    return /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(email)
  }

  const handleCaptchaCallback = useCallback((err, isValid) => {
    if (err) return
    setCaptchaIsValid(isValid)
  }, [])

  const showToastNotification = (title, message, variant = 'info') => {
    setToastTitle(title)
    setToastMessage(message)
    setToastVariant(variant)
    setShowToast(true)
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    setMessage('')

    try {
      // Validate form
      if (!email || email === '') {
        throw new Error('Email cannot be empty')
      }
      if (!validateEmail(email)) {
        throw new Error('Email must be in valid format')
      }
      if (!formMessage || formMessage === '') {
        throw new Error('Message cannot be empty')
      }
      if (!captchaIsValid) {
        throw new Error('Captcha is invalid')
      }

      setIsSubmitting(true)

      const obj = {
        name,
        email,
        formMessage,
        subject: 'Contact form from FullStack.cash',
        emailList: ['chris.troutner@gmail.com'],
        payloadTitle: 'placeholder'
      }

      const resp = await fetch(`${SERVER}/contact/email`, {
        method: 'POST',
        mode: 'cors',
        body: JSON.stringify({ obj }),
        headers: {
          'Content-Type': 'application/json'
        }
      })

      const data = await resp.json()
      console.log(`data: `, data)

      if (data.success) {
        console.log('success')
        showToastNotification('Success!!', 'Thank you!', 'success')
        setShowSuccess(true)
        setShowError(false)
        // Reset form
        setName('')
        setEmail('')
        setFormMessage('')
        setCaptchaIsValid(false)
      } else {
        console.log('error 1')
        showToastNotification('Error', 'An error occurred.', 'danger')
        setShowError(true)
        setShowSuccess(false)
      }
    } catch (err) {
      console.log('error 2')
      showToastNotification('Error', err.message, 'danger')
      setMessage(err.message)
      setShowError(true)
      setShowSuccess(false)
    } finally {
      console.log('finally')
      setIsSubmitting(false)
    }
  }

  let content

  if (showSuccess) {
    content = (
      <Alert variant='success'>
        <h4><strong>Thank you!</strong></h4>
        <p>
          An email has been dispatched to the site owner. We will respond as
          soon as possible.
        </p>
      </Alert>
    )
  } else if (showError) {
    content = (
      <Alert variant='danger'>
        <h4><strong>Error!</strong></h4>
        <p>
          An error occurred. Try reloading this page and trying again. If it
          continues, please try again later.
        </p>
        <Button
          variant='outline-danger' onClick={() => {
            setShowError(false)
            setShowSuccess(false)
          }}
        >
          Try Again
        </Button>
      </Alert>
    )
  } else {
    content = (
      <Form onSubmit={handleSubmit}>
        <Form.Group className='mb-3'>
          <Form.Label><strong>Name:</strong> (How we should address you in email)</Form.Label>
          <Form.Control
            type='text'
            name='name'
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder='John Doe'
          />
        </Form.Group>

        <Form.Group className='mb-3'>
          <Form.Label><strong>Email:</strong></Form.Label>
          <Form.Control
            type='email'
            name='email'
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder='your@email.com'
          />
        </Form.Group>

        <Form.Group className='mb-3'>
          <Form.Label><strong>Message:</strong></Form.Label>
          <Form.Control
            as='textarea'
            rows={3}
            name='formMessage'
            value={formMessage}
            onChange={(e) => setFormMessage(e.target.value)}
            placeholder='Your message here...'
          />
        </Form.Group>

        {message && (
          <Alert variant='danger'>{message}</Alert>
        )}

        <Captcha callback={handleCaptchaCallback} />

        <Button
          type='submit'
          variant='primary'
          disabled={isSubmitting || !captchaIsValid}
          className='mt-3'
        >
          {isSubmitting ? 'Sending...' : 'Send Message'}
        </Button>
      </Form>
    )
  }

  return (
    <>
      {content}
      <ToastContainer position='top-end' className='p-3' style={{ zIndex: 1055 }}>
        <Toast
          show={showToast}
          onClose={() => setShowToast(false)}
          bg={toastVariant}
          delay={3000}
          autohide
        >
          <Toast.Header>
            <strong className='me-auto'>{toastTitle}</strong>
          </Toast.Header>
          <Toast.Body className={toastVariant === 'danger' ? 'text-white' : ''}>
            {toastMessage}
          </Toast.Body>
        </Toast>
      </ToastContainer>
    </>
  )
}

export default ContactForm
